export type SopToolMetadata = {
  label: string;
  detailInputKey?: string;
  summarize: (count: number) => string;
};

export type SopMcpToolName = 'mcp__sop__next' | 'mcp__sop__definition' | 'mcp__sop__explain';

const plural = (count: number, singular: string, plural = `${singular}s`) =>
  `${count} ${count === 1 ? singular : plural}`;

const SOP_TOOL_METADATA = {
  mcp__sop__next: {
    label: 'Advancing SOP',
    summarize: count => (count === 1 ? 'advanced the SOP' : `advanced the SOP ${count} times`),
  },
  mcp__sop__definition: {
    label: 'Reading SOP field definition',
    detailInputKey: 'field',
    summarize: count => `read ${plural(count, 'SOP definition')}`,
  },
  mcp__sop__explain: {
    label: 'Explaining SOP field',
    detailInputKey: 'field',
    summarize: count => `explained ${plural(count, 'SOP field')}`,
  },
} satisfies Record<SopMcpToolName, SopToolMetadata>;

export const isSopMcpToolName = (toolName: string): toolName is SopMcpToolName => toolName in SOP_TOOL_METADATA;

export const getSopToolMetadata = (toolName: SopMcpToolName): SopToolMetadata => SOP_TOOL_METADATA[toolName];
